<template>
  <div class="share">
    <div class="share_title">
      <p><i class="iconfont icon-shoucang5"></i>{{$t('DataServer.sharingPlatform')}}</p>
    </div>
    <swiper :options="swiperOption" ref="mySwiper1">
      <swiper-slide v-for="(item, index) in sharePlatform" :key="index">
        <div
          class="sdg_box"
          @mouseenter="on_bot_enter"
          @mouseleave="on_bot_leave"
          @click="toOtherWeb(item)"
        >
          <img
            class="banner_img"
            :src="require(`@/assets/image/DataHub/${index}.jpg`)"
            alt="image"
          />
        </div>
      </swiper-slide>
    </swiper>
    <!-- <div class="swiper-button-prev">
      <i class="iconfont icon-jiantou2"></i>
    </div>
    <div class="swiper-button-next">
      <i class="iconfont icon-jiantou"></i>
    </div> -->
  </div>
</template>

<script>
// 引入插件
import { mapMixin } from "@/util/mixin";
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
import {
  swiperAnimateCache,
  swiperAnimate,
} from "@/assets/js/swiper.animate1.0.3.min.js";
import "swiper/dist/css/swiper.css";
export default {
  mixins: [mapMixin],
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    Pagination,
  },
  data() {
    return {
      sharePlatform: ['https://www.deepbone.cn/home/','http://databank.casearth.cn/#dlv=Wzg4LFswLDIwLDEsMF0sW1siZGF0YWRhdGUiLDFdXSxbXSw5OV0%3D','http://msdc.qdio.ac.cn/','http://poles.tpdc.ac.cn/zh-hans/','https://www.bio-one.org.cn/'],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          //自动轮播
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          init: function () {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function () {},
          slideChangeTransitionEnd: function () {},
          slideChange: function () {
            swiperAnimate(this);
          },
        },
      },
    };
  },
  computed: {
    swiper1() {
      return this.$refs.mySwiper1.swiper;
    },
  },
  mounted() {},
  methods: {
      toOtherWeb(url){
          window.open(url,'_blank')
      },
    on_bot_enter() {
      //鼠标放上暂停轮播
      this.swiper1.autoplay.stop();
    },
    on_bot_leave() {
      this.swiper1.autoplay.start();
    },
  },
};
</script>

<style lang="scss" >
// @media screen and (min-width: 1026px) {
  .share {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    padding: 20px 34px;
    margin: 20px auto 0;
    position: relative;
    overflow: hidden;
    height: 210px;
    .share_title {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: rgba(255, 91, 41, 1);
      i {
        font-size: 22px;
        margin-right: 6px;
      }
      font-weight: 600;
      font-size: 16px;
    }
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      background: none;
      display: flex;
      align-items: center;
    }
    .swiper-button-prev {
      left: 0px;
      top: 130px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
        background:rgba(230, 230, 230, 1);
        padding: 10px 10px 10px 2px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        color: #fff;
      }
    }
    .swiper-button-next {
      right: -2px;
      top: 130px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
           background:rgba(230, 230, 230, 1);
        padding: 10px 4px 10px 10px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        color: #fff;
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .sdg_box {
      cursor: pointer;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .banner_img {
        &:hover {
            overflow: hidden;
          border-radius: 4px;
          transition: 0.2s;
          transform: scale(1.05);
        }
        transition: 0.2s;
        overflow: hidden;
        object-fit: cover;
        width: 100%;
        height: 135px;
        border-radius: 4px;
      }
      p {
        margin-top: 8px;
        font-size: 14px;
      }
    }
  }
// }
</style>